import Layout, { Stack } from '@/components/Layout'
import { HelpInfoPageSection } from '@/shared/api-generated-types'
import HelpInfo from '@/widgets/HelpInfo'
import React from 'react'

export interface Props extends Partial<HelpInfoPageSection> {}

const HelpInfoBlock = ({ items }: Props): JSX.Element | null => {
  if (!items?.length) return null

  return (
    <div className="pb-md">
      <Layout spacing="md">
        <Stack y>
          {items.map((item, index) => (
            <HelpInfo key={index} {...item} />
          ))}
        </Stack>
      </Layout>
    </div>
  )
}
export default React.memo(HelpInfoBlock)
